import axios from "axios";
import { client } from "../App";
import { getToken } from "../utilities/utilsFunction";

import {
  GET_ALL_MODEL_FEATURE_LIST,
  GET_GROUP_FEATURE_LIST,
} from "./machine.queries";
import { DOMAIN } from "../constant";

// Get All Machine Feature Mapping
export const GetAllMachineFeatureMapping = () =>
  new Promise((resolve, reject) => {
    client
      .query({
        query: GET_ALL_MODEL_FEATURE_LIST,
        variables: {},
        fetchPolicy: "no-cache",
      })
      .then(({ data }) => {
        if (data?.fetchFeatureModelConfigList) {
          resolve(data?.fetchFeatureModelConfigList);
        } else {
          reject("Invalid Request");
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

// Get All Features and Features Group
export const GetAllGroupFeatures = () =>
  new Promise((resolve, reject) => {
    client
      .query({
        query: GET_GROUP_FEATURE_LIST,
        variables: {},
        fetchPolicy: "no-cache",
      })
      .then(({ data }) => {
        if (data?.fetchProductGrpFeatureList) {
          resolve(data?.fetchProductGrpFeatureList);
        } else {
          reject("Invalid Request");
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

// Upload Machine Variant Image
export const UploadVariantImage = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "post",
      url: `${DOMAIN}/machine/ag/ma/updateVariantMst`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: await getToken(),
        version: "v2",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

// Upload Machine Model Doc
export const UploadModelDoc = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "post",
      url: `${DOMAIN}/machine/ag/ma/updateModelConfig`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: await getToken(),
        version: "v2",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

// Add Machine Variant Features
export const AddVariantFeatures = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "post",
      url: `${DOMAIN}/machine/ag/ma/createFeatureMap`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

// Update Machine Feature Details
export const UpdateFeatureDetail = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "post",
      url: `${DOMAIN}/machine/ag/ma/updateProductFeatureDetails`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

// Disable Variant Feature
export const DisableVariantFeature = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "delete",
      url: `${DOMAIN}/machine/ag/ma/deleteProductGrpFeatureVariantMap`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

// Enable Variant Feature
export const EnableVariantFeature = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "put",
      url: `${DOMAIN}/machine/ag/ma/updateProductGrpFeatureVariantMap`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
